import { render, staticRenderFns } from "./off.vue?vue&type=template&id=1f7ab3e6&"
import script from "./off.vue?vue&type=script&lang=js&"
export * from "./off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7ab3e6')) {
      api.createRecord('1f7ab3e6', component.options)
    } else {
      api.reload('1f7ab3e6', component.options)
    }
    module.hot.accept("./off.vue?vue&type=template&id=1f7ab3e6&", function () {
      api.rerender('1f7ab3e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/page-cache/off.vue"
export default component.exports